module.exports = __webpack_public_path__ + "static/media/b3.ac5e3f8a.svg";